const fragmentCategory = `
  fragment CategoryFields on CategoryTree {
    include_in_menu
    id
    is_anchor
    name
    image
    mobile_banner_image
    category_popular_sku
    product_count
    children_count
    uid
    url_path
    url_suffix
    category_thumbnail_image
    category_thumbnail_image_2
    level
    position
  }
`;

export default `
  query categoryList($filters: CategoryFilterInput, $pageSize: Int = 20) {
    categoryList(filters: $filters, pageSize: $pageSize) {
      ...CategoryFields
      children {
        ...CategoryFields
        children {
          ...CategoryFields
          children {
            ...CategoryFields
          }
        }
      }
    }
  }
  ${fragmentCategory}
`;
